export default async function createRentCalcs(containerSelector = '.js-rent-form', debug = false) {
  let containers = document.querySelectorAll(containerSelector);
  if (! containers.length) return;

  window.addEventListener('load', event => {
    init();
  });

  async function init() {
    const { default: RentCalc } = await import('../classes/RentCalc');
  
    containers.forEach(container => {
      new RentCalc(container);
    });
  }
}
